/**
 * Purpose:
 *   Preload subscriptions list table JS chunk on menu intent.
 */

export function warmSubscriptionsListChunk(): void {
  void import(
    '@/features/subscription/subscriptionsList/components/SubscriptionsPageTable/SubscriptionsPageTable'
  );
}